import {Stack} from 'shells/layout/stack/stack';

import {SearchResultNavigation} from './search-result-navigation';
import {SectionHeader} from './section-header';
import type {NavigationItem} from './types';

interface Props {
    items: NavigationItem[];
    activeIndex: number;
    startIndex: number;
    resultRefs: React.MutableRefObject<(HTMLElement | null)[]>;
    onClick: (id: string) => void;
}

export function FrecentSection(props: Props) {
    return (
        <Stack isFullWidth>
            <SectionHeader>Suggested</SectionHeader>
            {props.items.map((item, index) => {
                const idx = props.startIndex + index;

                return (
                    <SearchResultNavigation
                        key={item.id}
                        item={item}
                        isActive={idx === props.activeIndex}
                        innerRef={(element) => (props.resultRefs.current[idx] = element)}
                        onClick={() => props.onClick(item.id)}
                    />
                );
            })}
        </Stack>
    );
}
